import type { LocationDescriptor, Path } from 'history';

const getLocationPathname = (location: Path | LocationDescriptor) => {
  return typeof location === 'string' ? location : location.pathname;
};

export default getLocationPathname;
